import { v4 as uuidv4 } from "uuid";
import ActiveFilterDTO = App.Data.Explorer.Filter.ActiveFilterDTO;
import SegmentDO = App.Data.Segments.SegmentDO;
import SegmentPartDO = App.Data.Segments.SegmentPartDO;
import DocumentVerticalDTO = App.Data.DocumentVerticalDTO;
import SegmentSummaryOperator = App.Enums.SegmentSummaryOperator;
import SegmentPartType = App.Enums.SegmentPartType;
import SegmentType = App.Enums.SegmentType;

export function loadNewPart(
	data_source: string = "tab_occ_prk_v",
	type: SegmentPartType = "include",
	active_filters: ActiveFilterDTO[] = [],
	metric: DocumentVerticalDTO = null,
	operator: SegmentSummaryOperator = null,
	values: number[] = [0, 0]
): SegmentPartDO {
	return {
		type,
		data_source,
		active_filters,
		metric,
		operator,
		values,
	};
}

export function loadNewSegment(
	parts?: SegmentPartDO[],
	type: SegmentType = "customer"
): SegmentDO {
	return {
		uuid: uuidv4(),
		user_id: null,
		title: "",
		description: "",
		type: type,
		computed_size: null,
		has_dependency_on_lost_customer_segment: false,
		parts: parts ?? [loadNewPart()],
	};
}
